@if(data$ | async; as data){
  @if (iconName$ | async; as iconName) {
    <mat-icon class="link-icon" [svgIcon]="iconName"/>
  }
  <cx-generic-link [attr.data-test]="data.uid"
    [url]="data.localizedUrl || data.url"
    [style]="data.styleAttributes"
    [target]="getTarget(data)"
    (click)="linkClicked(data.javaScript)"
  >{{ data.linkName }}</cx-generic-link
  >

}
